import styled from "styled-components"
import { device } from "breakpoints"

import { Button } from "components/Button"
import { getGradient } from "helpers/getGradient"

const getDifferentGradient = props => {
  if (props === "work") {
    return getGradient("business")
  } else if (props === "business") {
    return getGradient("live")
  } else if (props === "live") {
    return getGradient("visit")
  } else if (props === "visit") {
    return getGradient("work")
  } else if (props === "study") {
    return getGradient("live")
  } else {
    return getGradient("live")
  }
}

export const InternalRHSCTAButton = styled(Button)`
  font-weight: 600;
  font-size: 16px;
  letter-spacing: -0.12px;
  line-height: 24px;
  margin-bottom: 20px;
  background: transparent;
  border: none;
  padding: 0;

  @media ${device.large} {
    font-size: 18px;
    letter-spacing: -0.14px;
    line-height: 27px;
  }

  span {
    border-bottom: 1px solid white;
    line-height: 110%;
  }

  :before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
  }
`

export const InternalRHSCTAContainer = styled.div`
  background: ${props => getDifferentGradient(props.theme.site)};
  padding: 23px 29px 5px;
  margin-bottom: 40px;
  cursor: pointer;
  position: relative;

  @media ${device.tablet} {
    margin-left: 10px;
    width: 50%;
  }
  @media ${device.desktop} {
    margin-left: 0;
    width: 100%;
  }

  :hover {
    ${InternalRHSCTAButton} {
      span {
        border-bottom: 1px solid transparent;
      }
    }
  }

  :before,
  :after {
    @media ${device.tablet} {
      background-color: #fff;
      content: "";
      display: block;
      height: 1px;
      left: calc(50%);
      position: absolute;
      right: 0;
      transform-origin: 50%;
      z-index: -1;
      width: 100%;
      opacity: 0.5;
    }
  }

  :before {
    z-index: 1;
    @media ${device.tablet} {
      bottom: 70px;
      transform: rotate(-35deg) translateX(-50%);
    }
    @media ${device.large} {
      bottom: 70px;
      transform: rotate(-29deg) translateX(-50%);
    }
  }

  :after {
    z-index: 1;
    bottom: 40px;
    transform: rotate(-11deg) translateX(-30%);

    @media ${device.large} {
      bottom: 40px;
      transform: rotate(-12deg) translateX(-30%);
    }
  }

  @media ${device.desktop} {
    display: block;
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
    padding: 30px 27px;
    padding-bottom: 9px;
  }
`

export const Title = styled.h4`
  font-weight: 700;
  font-size: 20px;
  letter-spacing: -0.21px;
  line-height: 22px;
  color: #ffffff;
  margin-bottom: 19px;

  @media ${device.large} {
    font-size: 24px;
    letter-spacing: -0.25px;
    line-height: 24px;
    margin-bottom: 25px;
  }
`

export const Excerpt = styled.p`
  font-weight: 500;
  color: #ffffff;
  font-size: 16px;
  letter-spacing: -0.12px;
  line-height: 24px;
  margin-bottom: 13px;

  @media ${device.large} {
    font-size: 18px;
    letter-spacing: -0.14px;
    line-height: 27px;
    margin-bottom: 10px;
  }
`
